import apiFaq from '@/api/faq'

const state = {
    error: null,
    isSubmitting: false
}

export const mutationTypes = {
    deleteFaqStart: '[delete faq] Delete faq start',
    deleteFaqSuccess: '[delete faq] Delete faq success',
    deleteFaqFailure: '[delete faq] Delete faq failure'
}

export const actionTypes = {
    deleteFaq: '[delete faq] Delete faq'
}

const mutations = {
    [mutationTypes.deleteFaqStart](state) {
        state.isSubmitting = true
    },

    [mutationTypes.deleteFaqSuccess](state) {
        state.isSubmitting = false
    },

    [mutationTypes.deleteFaqFailure](state, payload) {
        state.error = payload
        state.isSubmitting = false
    }
}

const actions = {
    [actionTypes.deleteFaq](context, {id}) {
        context.commit(mutationTypes.deleteFaqStart)
        return new Promise(resolve => {
            apiFaq
                .deleteFaq(id)
                .then(response => {
                    context.commit(mutationTypes.deleteFaqSuccess)
                    resolve(response.data)
                })
                .catch(resolve => {
                    context.commit(
                        mutationTypes.deleteFaqFailure,
                        resolve.response.data.errors
                    )
                })
        })
    }
}

export default {
    state,
    mutations,
    actions
}
